import { render, staticRenderFns } from "./RecurrenceSettings.vue?vue&type=template&id=b31f11c0"
import script from "./RecurrenceSettings.vue?vue&type=script&lang=ts"
export * from "./RecurrenceSettings.vue?vue&type=script&lang=ts"
import style0 from "./RecurrenceSettings.vue?vue&type=style&index=0&id=b31f11c0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports